import { render, staticRenderFns } from "./EnterOtp.vue?vue&type=template&id=fa52c5ac&scoped=true&"
import script from "./EnterOtp.vue?vue&type=script&lang=js&"
export * from "./EnterOtp.vue?vue&type=script&lang=js&"
import style0 from "./EnterOtp.vue?vue&type=style&index=0&id=fa52c5ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa52c5ac",
  null
  
)

export default component.exports